<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 30 30"
         :width="size ? size : 512" :height="size ? size : 512">
        <path :style="css" :class="[color]" d="M 15 1 A 14 14 0 1 0 29 15 A 14.015 14.015 0 0 0 15 1 z M 14.501953 3.0097656 A 12 12 0 0 1 27 15 A 12.013 12.013 0 0 1 15 27 A 12 12 0 0 1 14.501953 3.0097656 z M 21.925781 9.0136719 A 1 1 0 0 0 21.292969 9.2929688 L 12 18.585938 L 8.7070312 15.292969 A 1 1 0 1 0 7.2929688 16.707031 L 11.292969 20.707031 A 1 1 0 0 0 12.707031 20.707031 L 22.707031 10.707031 A 1 1 0 0 0 21.925781 9.0136719 z"></path>
    </svg>
</template>

<script>
export default {
    name: "IconCheck",

    props: {
        color: '',
        size: '',
    },

    computed: {
        css(){
            return '';
        }
    }

}
</script>
<style lang="scss" scoped>
//svg{
//    width: auto;
//    height: 1em;
//}

path{
    fill: white;
}

.dark{
    fill: $dark;
}

.success, .success path{
    fill: $success !important;
}
</style>
